module.exports = __webpack_public_path__ + "img/img76.ab79f258.png";